module.exports = __WEBPACK_EXTERNAL_MODULE_vue__;


// WEBPACK FOOTER //
// webpack:/Vuetify/external {"commonjs":"vue","commonjs2":"vue","amd":"vue","root":"Vue"}